import {useEffect, useRef} from 'react';
import {type UseFormSetValue} from 'react-hook-form';
import {SelectOption, DocumentChoice, GUEST_FORM_NAMES} from '@chekin/core';
import {
  useIVStore,
  getDocumentType,
  getDocumentNationality,
  useFetchLocations,
} from '@chekin/shared';
import {FormTypes} from './types';

type InitDocumentTypeProps = {
  nationality?: SelectOption;
  options: SelectOption<DocumentChoice>[];
  setValue: UseFormSetValue<FormTypes>;
};
export const useInitDocumentType = ({
  options,
  setValue,
  nationality,
}: InitDocumentTypeProps) => {
  const isNotCheckedRef = useRef<boolean>(true);
  const documentType = useIVStore(getDocumentType);

  useEffect(() => {
    if (isNotCheckedRef.current && nationality && options.length) {
      isNotCheckedRef.current = false;
      const documentTypeOption = options.find(
        option => option.value === documentType?.value,
      );

      if (documentTypeOption) {
        setValue(GUEST_FORM_NAMES.document_type, documentTypeOption);
      }
    }
  }, [documentType, nationality, options, setValue]);
};

type InitNationalityProps = {
  setValue: UseFormSetValue<FormTypes>;
};
export const useInitNationality = ({setValue}: InitNationalityProps) => {
  const isNotCheckedRef = useRef<boolean>(true);
  const {isLoadingLocations, locationsAsOptions} = useFetchLocations();
  const nationality = useIVStore(getDocumentNationality);

  useEffect(() => {
    if (isNotCheckedRef.current && !isLoadingLocations) {
      isNotCheckedRef.current = false;
      const locationOption = locationsAsOptions.find(
        location => location.value === nationality,
      );

      if (locationOption) {
        setValue(GUEST_FORM_NAMES.nationality, locationOption);
      }
    }
  }, [isLoadingLocations, locationsAsOptions, nationality, setValue]);
};
